<script>
import { dataset_dev } from "svelte/internal";
import Footer from "../components/Footer.svelte";
import Header from "../components/header/Header.svelte";
import Modals from "../components/Modals.svelte";
import TopbarSignedIn from "../components/TopbarSignedIn.svelte";

let complaint = {
  articlenumber: "108080",
  arrend: "166734",
  product: "Handtag 835S KR X=53",
  date: "2020-11-25",
  amount: "1",
  price: "343",
  sum: "343",
};
</script>

<div class="container" id="wrapper">
  <TopbarSignedIn />
  <Header />
  <div class="complaint-two">
    <div class="row">
      <div class="col-xs-12">
        <div class="row fill-white">
          <div class="col-xs-12">
            <div id="content" class="main-content">
              <script type="text/javascript">
              $(document).ready(function () {
                $("#checkboxall").click(function () {
                  var checked_status = this.checked;
                  $("input[name=CHK_checkbox]").each(function () {
                    this.checked = checked_status;
                  });
                });
              });

              function forward() {
                document.form.OPT.value = "2";
                //alert(document.form.OPT.length)
                for (i = 0; i < document.form.OPT.length; i++) {
                  document.form.OPT[i].value = "2";
                  document.form.LAST[i].value = "N";
                }
                if (document.form.OPT.length > 0) {
                  document.form.LAST[document.form.OPT.length - 1].value = "J";
                }
                var chkbxs = document.getElementsByName("CHK_checkbox");
                var chk = document.getElementsByName("CHK");
                var checkedboxes = 0;
                for (i = 0; i < chkbxs.length; i++) {
                  if (chkbxs[i].checked == true) {
                    chk[i].value = "J";
                    checkedboxes++;
                  } else {
                    chk[i].value = "N";
                  }
                }
                if (checkedboxes > 0) {
                  document.form.submit();
                } else {
                  alert("Du har inte valt några artiklar att reklamera");
                }
              }
              </script>
              <!-- contenttop -->
              <div id="contenttop" class="row">
                <div class="col-xs-12">
                  <ul class="breadcrumb">
                    <li class="active">Min sida</li>
                    <li>
                      <a href="/shop/IboxServlet?p=IXS850">Reklamation / retur</a>
                    </li>
                  </ul>
                </div>
              </div>

              <!-- Workflow -->
              <div class="workflow">
                <ul class="breadcrumb breadcrumb-secondary mt-md">
                  <li><a href="#"><span>1. Ärende</span></a></li>
                  <li class="active-step"><span>2. Rader</span></li>
                  <li><a href="#"><span>3. Anmärkningar</span></a></li>
                  <li><a href="#"><span>4. Leveransadress</span></a></li>
                  <li><a href="#"><span>5. Boka</span></a></li>
                  <li><a href="#"><span>6. Kvitto</span></a></li>
                </ul>
              </div>
              <!-- Ny reklamation / retur -->

              <div class="row">
                <div class="col-xs-12 mt-sm">
                  <h2>Ny reklamation / retur</h2>
                </div>
              </div>
              <div class="border-frame">
                <form
                  class="full cart"
                  action="/shop/IboxServlet"
                  method="post"
                  accept-charset="utf-8"
                  onSubmit="return update()"
                  name="form"
                >
                  <input type="hidden" name="p" value="IXS855" />
                  <input type="hidden" name="OPT" value="2" />
                  <input type="hidden" name="LAST" value="J" />
                  <input type="hidden" name="LAD1" value="" />
                  <input type="hidden" name="LAD2" value="" />
                  <input type="hidden" name="LAD3" value="" />
                  <input type="hidden" name="LPNR" value="" />
                  <input type="hidden" name="LORT" value="" />

                  <div class="table-responsive col-sm-12">
                    <p>Välj de produkter du vill reklamera.</p>
                    <table class="table">
                      <thead class="table-header-inverse">
                        <tr>
                          <th class="first">
                            <div class="form-checkbox">
                              <input
                                id="checkboxall"
                                type="checkbox"
                                title="Markera alla"
                              />
                              <label for="checkboxall"></label>
                            </div>
                          </th>
                          <th>Artikel</th>
                          <th>Ärende</th>
                          <th>Benämning</th>
                          <th>Antal</th>
                          <th>Pris</th>
                          <th>Belopp</th>
                          <th>Fakturadatum</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="odd" valign="top">
                          <td class="first">
                            <div class="form-checkbox">
                              <input
                                type="checkbox"
                                name="CHK_checkbox"
                                value="J"
                                id="reklamation1"
                              />
                              <label for="reklamation1"></label>
                            </div>
                          </td>
                          <td>{complaint.articlenumber}</td>
                          <td>{complaint.arrend}</td>
                          <td class="bold">{complaint.product}</td>
                          <td>{complaint.amount} st</td>
                          <td>{complaint.price} SEK</td>
                          <td>{complaint.sum} SEK</td>
                          <td>{complaint.date}</td>
                        </tr>
                        <tr class="even" valign="top">
                          <td class="first">
                            <div class="form-checkbox">
                              <input
                                type="checkbox"
                                name="CHK_checkbox"
                                value="J"
                                id="reklamation2"
                              />
                              <label for="reklamation2"></label>
                            </div>
                          </td>
                          <td>{complaint.articlenumber}</td>
                          <td>{complaint.arrend}</td>
                          <td class="bold">{complaint.product}</td>
                          <td>{complaint.amount} st</td>
                          <td>{complaint.price} SEK</td>
                          <td>{complaint.sum} SEK</td>
                          <td>{complaint.date}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </form>
                <button
                  onclick="forward()"
                  type="button"
                  class="button btn btn-primary"
                ><span>Nästa</span></button>
              </div>
            </div>
          </div>
        </div>
        <!--padd -->
      </div>
    </div>
  </div>

  <div class="col-xs-12 col-sm-3 sidebar-secondary"></div>
</div>

<Footer />
<Modals />
